import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ThemeSettingsPage from "../../components/comprobantes/ThemeSettingsPage";

const Theme = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Thema" />

        <ThemeSettingsPage />

      </MasterLayout>

    </>
  );
};

export default Theme; 
